import * as de from 'svg-country-flags/svg/de.svg'
import * as en from 'svg-country-flags/svg/gb.svg'
import * as fr from 'svg-country-flags/svg/fr.svg'
import * as tr from 'svg-country-flags/svg/tr.svg'
import * as pl from 'svg-country-flags/svg/pl.svg'
import * as es from 'svg-country-flags/svg/es.svg'
import * as nl from 'svg-country-flags/svg/nl.svg'
import * as pt from 'svg-country-flags/svg/pt.svg'
import * as it from 'svg-country-flags/svg/it.svg'
import * as ru from 'svg-country-flags/svg/ru.svg'
import * as bg from 'svg-country-flags/svg/bg.svg'

export default [
    {
        locale: 'de',
        label: 'Deutsch',
        flag: de,
    },
    {
        locale: 'en',
        label: 'English',
        flag: en,
    },
    {
        locale: 'fr',
        label: 'Français',
        flag: fr,
    },
    {
        locale: 'tr',
        label: 'Türkce',
        flag: tr,
    },
    {
        locale: 'pl',
        label: 'Polski',
        flag: pl,
    },
    {
        locale: 'es',
        label: 'Español',
        flag: es,
    },
    {
        locale: 'nl',
        label: 'Nederlands',
        flag: nl,
    },
    {
        locale: 'pt',
        label: 'Portuguese',
        flag: pt,
    },
    {
        locale: 'it',
        label: 'Italiano',
        flag: it,
    },
    {
        locale: 'ru',
        label: 'русский',
        flag: ru,
    },
    {
        locale: 'bg',
        label: 'български',
        flag: bg,
    },
]
